export default __webpack_public_path__ + "static/picto-warranty-black-bc2fd3c20408f0e0abb448aef98caaf0.png";